import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/pro-regular-svg-icons';
import Button from '../shared/button';
import advancedEditorIntroGif from 'images/advanced_email_editor_intro.gif';

type Props = {
  designVersionId: number;
  createMessagePath: string;
  dismissPath: string;
};

export default function AdvancedEditorIntroModal({ designVersionId, createMessagePath, dismissPath }: Props) {
  const [show, setShow] = useState(true);
  const formRef = useRef<HTMLFormElement>(null);

  if (!show) return null;

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

  function markAsSeen() {
    return fetch(dismissPath, {
      method: 'POST',
      headers: { 'X-CSRF-TOKEN': csrfToken },
    });
  }

  function dismiss() {
    markAsSeen();
    setShow(false);
  }

  async function handleTryIt() {
    await markAsSeen();
    sessionStorage.setItem('showTemplateTooltip', 'true');
    formRef.current?.submit();
  }

  return (
    <>
      <Modal centered contentClassName="border-0 overflow-hidden" show size="lg" onHide={dismiss}>
        <Modal.Header
          className="position-absolute top-0 end-0 border-0"
          closeButton
          style={{ zIndex: 1 }}
        />
        <img
          alt="Advanced Email Editor"
          className="w-100"
          src={advancedEditorIntroGif}
          style={{ objectFit: 'cover' }}
        />
        <Modal.Body style={{ padding: 16 }}>
          <span
            className="badge mb-3"
            style={{
              background: 'var(--badge-accent-secondary-bg, #EFF6FF)',
              color: 'var(--badge-accent-secondary-color)',
            }}
          >
            <FontAwesomeIcon className="me-1" icon={faRocket} />
            Early Access
          </span>
          <Modal.Title as="h3" style={{ marginBottom: 4 }}>
            Introducing the Drag ‘n Drop Email Editor
          </Modal.Title>
          <p style={{ marginBottom: 16 }}>
            Drag, drop, and design professional marketing emails right inside
            Buildout — and get them out the door faster.
          </p>
          <div className="d-flex justify-content-end">
            <Button.Primary type="button" onClick={handleTryIt}>
              Try it out
            </Button.Primary>
          </div>
        </Modal.Body>
      </Modal>

      <form action={createMessagePath} method="post" ref={formRef} style={{ display: 'none' }}>
        <input name="authenticity_token" type="hidden" value={csrfToken} />
        <input name="bmail_message[context_type]" type="hidden" value="Bmail::PropertyEmail" />
        <input name="bmail_message[design_version_id]" type="hidden" value={designVersionId} />
      </form>
    </>
  );
}